export default "__VITE_ASSET__C7K4YHD9__"